export const promises = [
  {
    title: 'Free Estimates',
    description:
      'Call or text and we come out, measure, and give you a straight price in writing. No fees, no pressure.'
  },
  {
    title: 'Quality Work',
    description:
      'Proper prep, clean lines, full coverage. We do it right the first time and stand behind every wall we paint.'
  },
  {
    title: 'Friendly Service',
    description:
      'You talk to Micheal directly, start to finish. On time, respectful of your home, and cleaned up when we leave.'
  }
]
